import { useEffect, useState } from 'react';

export const AnimatedCounter = ({ end, suffix = '', duration = 2000 }) => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!end) return;

    let start = 0;
    const stepTime = Math.max(Math.floor(duration / end), 20);
    const counter = setInterval(() => {
      start += 1;
      setCount(start);
      if (start >= end) clearInterval(counter);
    }, stepTime);

    return () => clearInterval(counter);
  }, [end, duration]);

  return <span>{count}{end > 100 && suffix}</span>;
};
